import { Injectable, inject, signal } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { Observable, of, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SystemSettingService {
  private apiService = inject(ApiService);
  private cache = new Map<string, Observable<any>>();
  selectedSystemSetting = signal<string | undefined>(undefined);
  adjustForCovid = signal<boolean>(false);

  setSelectedSystemSetting(key: string | undefined): void {
    if (key === undefined) {
      this.selectedSystemSetting.set(undefined);
    }
    else {
      this.getSystemSettingValue(key).subscribe((result) => {
        this.selectedSystemSetting.set(result);
      })
    }

  }

  getSelectedSystemSetting() {
    return this.selectedSystemSetting();
  }

  setAdjustForCovid(adjusted: boolean): void {
    this.adjustForCovid.set(adjusted);
  }

  getAdjustedForCovid() {
    return this.adjustForCovid();
  }


  public getSystemSettingValue(key: string): Observable<string> {
    const cacheKey = `${key}-system-setting`;
    if (!this.cache.has(cacheKey)) {
      this.cache.set(cacheKey, this.apiService.get<string>(`/api/systemsetting/${key}`)
        .pipe(shareReplay(1)));
    }
    return this.cache.get(cacheKey) ?? of({} as string);
  }
}
